export const PWA_INSTALL_READY_EVENT = 'bizcare-install-prompt-ready';

export interface BeforeInstallPromptEvent extends Event {
    readonly platforms: string[];
    readonly userChoice: Promise<{
        outcome: 'accepted' | 'dismissed';
        platform: string;
    }>;
    prompt(): Promise<void>;
}

declare global {
    interface Window {
        __bizcareDeferredInstallPrompt?: BeforeInstallPromptEvent | null;
    }
}

export function capturePwaInstallPromptEarly(): void {
    if (typeof window === 'undefined') {
        return;
    }

    const w = window;
    w.__bizcareDeferredInstallPrompt ??= null;

    window.addEventListener('beforeinstallprompt', (event) => {
        const installEvent = event as BeforeInstallPromptEvent;
        installEvent.preventDefault();
        w.__bizcareDeferredInstallPrompt = installEvent;
        window.dispatchEvent(new Event(PWA_INSTALL_READY_EVENT));
    });
}

export function getCapturedPwaInstallPrompt(): BeforeInstallPromptEvent | null {
    if (typeof window === 'undefined') {
        return null;
    }

    return window.__bizcareDeferredInstallPrompt ?? null;
}

export function clearCapturedPwaInstallPrompt(): void {
    if (typeof window === 'undefined') {
        return;
    }

    window.__bizcareDeferredInstallPrompt = null;
}
